<template>
  <div class="home_block_3">
    <div class="hb3_left_top" @click="toWorkList('影像志')" :style="hb3LeftTopStyle">
      <ei-word :words="'影像志'" :active="active0" class="block-word"
               :class="{'color_change':color0}"></ei-word>
    </div>
    <div class="hb3_right_top" :style="hb3RightBgStyle">
      <el-carousel height="430px"
                   style="text-align: center"
                   :interval="3000"
                   :type="'card'"
                   :indicator-position="'none'"
                   :arrow="'always'" :autoplay="true">
        <el-carousel-item v-for="(item,index) in hb3RightImgList" :key="index" class="el-ca-item">
          <img :src="item.url" @click="toWorkList(item.link)"/>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="hb3_left_bottom" :style="hb3LeftBottomStyle">
      <ei-long-figure-scroll3 :url="homeblock3LeftDownBgImg" :width="3473"></ei-long-figure-scroll3>
    </div>
    <div class="hb3_right_bottom" :style="hb3RightBottomStyle">
      <ei-word :words="'松风阁'" :active="active0" class="block-word"
               :class="{'color_change':color0}"></ei-word>
    </div>
  </div>
</template>

<script>
import { queryHomeBlockInHomeAction } from '@/api/reception/home-api'
import { queryWorksAttachByTargetInfo } from '@/api/reception/works-api'
import { isFailure } from '@/eiuov-utils/axios/response'
import Vue from 'vue'
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload)
export default {
  name: 'EiHomeBlock3',
  data () {
    return {
      homeCarouselSmall9999: {},
      imageChronicle: '',
      qingJianji: '',
      calligraphyCollection: '',
      paintingCollection: '',
      active0: false,
      active1: false,
      active2: false,
      active3: false,
      color0: false,
      color1: false,
      color2: false,
      color3: false,
      hb3LeftTopStyle: {},
      hb3RightTopStyle1: {},
      hb3RightTopStyle2: {},
      hb3RightTopStyle3: {},
      hb3LeftBottomStyle: {},
      hb3RightBottomStyle: {},
      hb3RightBgStyle: {},
      titleButterflyImg: '/upload/homeBlock/1/titleButterflyImg.png',
      homeblock3LeftDownBgImg: require('./testImg/sfgs400.jpg'),
      currentInfo: {
        type: '',
        name: '',
        show: true,
        wordsActive: false,
      },
      vectorCurrent: {
        index: 0,
        name: '',
        url: '',
        show: true,
        width50: true,
        infoOpacity0: false,
        infoHidden: false
      },
      ebookCurrent: {
        index: 0,
        name: '',
        url: '',
        show: true,
        width50: false,
        infoOpacity0: true,
        infoHidden: true
      },
      videoCurrent: {
        index: 0,
        name: '',
        url: '',
        show: true,
        width50: false,
        infoOpacity0: true,
        infoHidden: true
      },
      changeType: 2,
      changeTime: 3000,
      changeTimer: null,
      homeBlockList: [],
      vectorList: [],
      ebookList: [],
      videoList: [],
      hb3RightImgList: [],
    }
  },
  created () {
    queryHomeBlockInHomeAction({ blockName: '首页模块3' }).then((res) => {
      if (isFailure(res)) return
      var list = res.data.list
      this.homeBlockList = list
      this.initHomeBlock(this.homeBlockList)
      let targetGuid = list[0].parentGuid
      let type = 10
      queryWorksAttachByTargetInfo({
        targetGuid,
        type
      }).then((res) => {
        if (isFailure(res)) return
        this.hb3RightImgList = res.data.worksAttach
      })
    })

    this.fourAndEight()
  },
  methods: {
    fourAndEight () {
      setInterval(() => {
        setTimeout(() => {
          this.color3 = false
          this.active0 = true
          setTimeout(() => {
            this.active1 = true
            setTimeout(() => {
              this.active2 = true
              setTimeout(() => {
                this.active3 = true
                setTimeout(() => {
                  this.active0 = false
                  this.color0 = true
                  setTimeout(() => {
                    this.active1 = false
                    this.color0 = false
                    this.color1 = true
                    setTimeout(() => {
                      this.active2 = false
                      this.color1 = false
                      this.color2 = true
                      setTimeout(() => {
                        this.active3 = false
                        this.color2 = false
                        this.color3 = true
                      }, 500)
                    }, 500)
                  }, 500)
                }, 3000)
              }, 500)
            }, 500)
          }, 500)
        }, 500)
      }, 6500)
    },
    initHomeBlock (list) {
      if (list.length === 0) return
      this.hb3LeftTopStyle = this.getBackGroundImage(list, '左上', 0)
      this.hb3RightTopStyle1 = this.getBackGroundImage(list, '右上1', 1)
      this.hb3RightTopStyle2 = this.getBackGroundImage(list, '右上2', 1)
      this.hb3RightTopStyle3 = this.getBackGroundImage(list, '右上3', 1)
      this.hb3LeftBottomStyle = this.getBackGroundImage(list, '左下', 0)
      this.hb3RightBottomStyle = this.getBackGroundImage(list, '右下', 0)
      this.hb3RightBgStyle = this.getBackGroundImage(list, '右背景', 0)
    },
    initVectorList (list) {
      if (list.length === 0) return
      this.vectorCurrent.name = list[0].name
      this.vectorCurrent.url = list[0].attach.url
      this.currentInfo.type = '矢量图'
      this.currentInfo.name = list[0].name
    },
    initEBookList (list) {
      if (list.length === 0) return
      this.ebookCurrent.name = list[0].name
      this.ebookCurrent.url = list[0].attach.url
    },
    initVideoList (list) {
      if (list.length === 0) return
      this.videoCurrent.name = list[0].name
      this.videoCurrent.url = list[0].attach.url
      this.initChangeTimer()
    },
    getBackGroundImage (list, name, type) {
      if (list.length === 0) return {}
      for (let i = 0; i < list.length; i++) {
        if (list[i].blockName === name && list[i].picture !== null) {
          if (1 == type) {
            return list[i].picture.url
          } else {
            return {
              backgroundImage: 'url(' + list[i].picture.url + ')'
            }
          }
        }
      }
      return {}
    },
    currentInfoOver () {
      this.currentInfo.wordsActive = true
      this.clearChangeTimer()
    },
    currentInfoOut () {
      this.currentInfo.wordsActive = false
      this.initChangeTimer()
    },
    initChangeTimer () {
      this.changeTimer = setInterval(() => {
        this.changeType++
        if (this.changeType > 2) this.changeType = 0
        if (this.changeType === 0) {
          this.changeEbookCurrent()
        } else if (this.changeType === 1) {
          this.changeVideoCurrent()
        } else if (this.changeType === 2) this.changeVectorCurrent()
      }, this.changeTime)
    },
    clearChangeTimer () {
      clearInterval(this.changeTimer)
      this.changeTimer = null
    },
    changeVectorCurrent () {
      this.vectorCurrent.show = false
      this.currentInfo.show = false
      setTimeout(() => {
        this.vectorCurrent.index++
        if (this.vectorCurrent.index >= this.vectorList.length) this.vectorCurrent.index = 0
        this.$set(this.vectorCurrent, 'name', this.vectorList[this.vectorCurrent.index].name)
        let url
        if (this.vectorList[this.vectorCurrent.index].attach) {
          url = this.vectorList[this.vectorCurrent.index].attach.url
        } else {
          url = ''
        }
        this.$set(this.vectorCurrent, 'url', url)
        this.vectorCurrent.show = true

        this.$set(this.vectorCurrent, 'width50', true)
        this.$set(this.ebookCurrent, 'width50', false)
        this.$set(this.videoCurrent, 'width50', false)

        this.currentInfo.type = '矢量图'
        this.currentInfo.name = this.vectorList[this.vectorCurrent.index].name
        this.currentInfo.show = true
      }, 400)
    },
    changeEbookCurrent () {
      this.ebookCurrent.show = false
      this.currentInfo.show = false
      setTimeout(() => {
        this.ebookCurrent.index++
        if (this.ebookCurrent.index >= this.ebookList.length) this.ebookCurrent.index = 0
        this.$set(this.ebookCurrent, 'name', this.ebookList[this.ebookCurrent.index].name)
        let url
        if (this.ebookList[this.ebookCurrent.index].attach) {
          url = this.ebookList[this.ebookCurrent.index].attach.url
        } else {
          url = ''
        }
        this.$set(this.ebookCurrent, 'url', url)
        this.ebookCurrent.show = true

        this.$set(this.vectorCurrent, 'width50', false)
        this.$set(this.ebookCurrent, 'width50', true)
        this.$set(this.videoCurrent, 'width50', false)

        this.currentInfo.type = '电子书'
        this.currentInfo.name = this.ebookList[this.ebookCurrent.index].name
        this.currentInfo.show = true
      }, 400)
    },
    changeVideoCurrent () {
      this.videoCurrent.show = false
      this.currentInfo.show = false
      setTimeout(() => {
        this.videoCurrent.index++
        if (this.videoCurrent.index >= this.videoList.length) this.videoCurrent.index = 0
        this.$set(this.videoCurrent, 'name', this.videoList[this.videoCurrent.index].name)
        let url
        if (this.videoList[this.videoCurrent.index].attach) {
          url = this.videoList[this.videoCurrent.index].attach.url
        } else {
          url = ''
        }
        this.$set(this.videoCurrent, 'url', url)
        this.videoCurrent.show = true

        this.$set(this.vectorCurrent, 'width50', false)
        this.$set(this.ebookCurrent, 'width50', false)
        this.$set(this.videoCurrent, 'width50', true)

        this.currentInfo.type = '电子书'
        this.currentInfo.name = this.videoList[this.videoCurrent.index].name
        this.currentInfo.show = true
      }, 400)
    },
    toWorkList (type) {
      this.$router.push({
        path: '/WorksList',
        query: { type: type }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@use "sass:math";
$hb3_width: 1600px;
$hb3_in_margin: 30px;
.color_change {
  animation: okkk 4s linear infinite;
  @keyframes okkk {
    0% {
      color: #67c23a
    }
    100% {
      color: #c30ce3
    }
  }
}


.home_block_3 {
  margin: 60px auto;
  width: $hb3_width;
  display: flex;
  flex-flow: wrap;
  justify-content: space-between;


  .title-bulb-layout {
    position: absolute;
    writing-mode: vertical-lr;
    letter-spacing: 40px;
    left: 172px;
    width: 100%;
    height: 100%;
    text-align: center;
    color: #ffff;
  }

  .hb3_left_top {
    position: relative;
    width: 380px;
    height: 430px;
    background-color: #A37D4C;
    margin-bottom: $hb3_in_margin;
    cursor: pointer;
  }

  .hb3_right_top {
    width: $hb3_width - 380 - 30;
    height: 430px;
    margin-bottom: 20px;
    background-color: #A37D4C;
    cursor: pointer;
  }

  $hb3_left_bottom_width: 1202px;

  .hb3_left_bottom {
    width: $hb3_left_bottom_width;
    height: 430px;
    position: relative;
    background-position: center;
    background-color: #7D1E21;

    .ei-long-figure-scroll3 {
      position: absolute;
      left: 13px;
      top: -75px;
    }
  }

  .hb3_right_bottom {
    width: $hb3_width - $hb3_left_bottom_width - $hb3_in_margin;
    height: 430px;
    position: relative;
    background-position: center;
    background-color: #A37D4C;
  }
}

.hb3_right_bottom {
  .title-bulb-layout {
    position: absolute;
    margin-left: -15px;
    top: 20px;
    right: 100px;
    writing-mode: vertical-lr;
    letter-spacing: 40px;
  }

  .title-bulb {
    font-size: 40px;
    font-weight: bolder;
    color: #333;
    cursor: pointer;
    letter-spacing: 40px;

    span {
      transition-duration: .5s;
      transition-delay: calc(var(--i) * .1s);
    }
  }
}


.hb3_right_bottom:hover .title-bulb span {
  color: #fff;
  text-shadow: 0 0 10px #fff,
  0 0 20px #fff,
  0 0 30px #fff,
  0 0 50px #fff,
  0 0 80px #fff;
}

.title-wrap {
  width: 80%;
  margin: 35px auto 5px;
  height: 50px;
  text-align: center;

  img:first-child {
    width: 25px;
    margin-right: 20px;
    vertical-align: middle;
  }

  img:last-child {
    width: 25px;
    margin-left: 20px;
    vertical-align: middle;
    transform: scaleX(-1);
  }

  span {
    display: inline-block;
    font-size: 28px;
    vertical-align: middle;
    line-height: 50px;
    color: #fff;
  }
}

// 大字标题（px 由 postcss 自动转 vw）
.block-word {
  font-size: 40px;
  color: #4755ef;
}

// 走马灯高度跟随视口等比缩放（覆盖组件内联的 430px，430/1920 ≈ 22.4vw）
::v-deep .el-carousel__container {
  height: 22.396vw !important;
}

::v-deep .el-carousel__mask {
  opacity: 0;
  width: 0;
}

::v-deep .el-carousel button{
  width: 50px;
  height: 50px;
  font-size: 40px;
}
::v-deep .el-carousel button:hover{
  background: rgba(0,0,0,0.3);
}

.el-ca-item img {
  height: 430px;
}


* img, span, a, div {
  user-select: none;
  -webkit-user-drag: none;
}
</style>
